import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, CTAMicroCopy } from '../CTAButton';
import { MOCKUP_IMAGE, stats } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-navy-50/60 px-4 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-182" data-mp="cw4h06fdrb07">
      <div className="mx-auto w-full max-w-4xl text-center" data-id="element-183" data-mp="huxsxuf0qty9">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="font-display text-lg font-bold tracking-tight text-navy-900 sm:text-xl" data-id="element-184" data-mp="hwio9m95qgx6">
          Dra. <span className="text-accent" data-id="element-185" data-mp="vmm51xp9pif8">Karito</span>
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-5 font-display text-[30px] font-black leading-[1.08] tracking-tight text-navy-950 sm:text-5xl md:text-6xl" data-id="element-186" data-mp="vof9d6cerqk2">
          Resuelve cualquier consulta de hipotiroidismo en{' '}
          <span className="text-accent" data-id="element-187" data-mp="9olyibol62of">menos de 3 minutos</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.12
      }} className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-navy-800/80 sm:text-lg" data-id="element-188" data-mp="4ogbj8t9h4co">
          Más de 2.000 médicos ya confían en la Dra. Karito. Descubre el sistema
          clínico que convierte la incertidumbre en decisiones claras, para que
          sepas exactamente cuándo tratar, qué prescribir y cómo ajustar la
          levotiroxina en cualquier escenario.
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.18
      }} src={MOCKUP_IMAGE} alt="Ruta Hipotiroidismo: 6 tomos digitales y 5 bonos exclusivos de la Dra. Karito" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-189" data-mp="emvx6w9irles" />

        <div className="mx-auto mt-6 w-full max-w-xl" data-id="element-190" data-mp="30mfks1nb49je">
          <CTAButton id="hero-cta" label="QUIERO LA RUTA HIPOTIROIDISMO AHORA" data-id="element-191" data-mp="35kqr42ee81wv" />
          <CTAMicroCopy text="Descarga inmediata · Sin suscripción · Acceso de por vida · Garantía de 7 días" data-id="element-192" data-mp="2qwvyem0dxxjs" />
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-4xl" data-id="element-193" data-mp="2vte2rkrsztvl">
        <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-194" data-mp="2hv69pnxw1cpp">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-navy-100 bg-white px-3 py-4 text-center" data-id="element-195" data-mp="2musk7pmc0eut">
              <dt className="sr-only" data-id="element-196" data-mp="27zmgxaemeu56">{stat.label}</dt>
              <dd data-id="element-197" data-mp="2cx4fc6v0hqyx">
                <span className="block font-display text-2xl font-black text-navy-900 sm:text-4xl" data-id="element-198" data-mp="2cwl93neq4r0q">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[11px] font-medium leading-snug text-navy-700/70 sm:text-sm" data-id="element-199" data-mp="b5hvcp9jewby">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-200" data-mp="1qp8qmbwvp0in">
          Deja de depender de las guías durante la consulta. Empieza a tomar
          decisiones con la seguridad de quien ya conoce el camino.
        </p>
      </div>
    </header>;
}